import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-quotes-instructions',
  templateUrl: './quotes-instructions.component.html',
  styleUrls: ['./quotes-instructions.component.scss']
})
export class QuotesInstructionsComponent {
  showNewQuoteVideo1 = false;
  showNewQuoteVideo2 = false;
  showAutoFillVideo = false;
  showAssistantVideo = false;

  constructor(private viewportScroller: ViewportScroller) {}

  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }
}
